/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-line': {
    width: 15,
    height: 12,
    viewBox: '0 0 15 12',
    data: '<path pid="0" _fill="#161616" d="M14 5a1 1 0 010 2H4.242l2.711 2.712c.222.221.085.718-.305 1.108-.391.39-.887.528-1.11.306L1.432 7.018a1.615 1.615 0 01-.406-.3 1.615 1.615 0 01-.3-.405L.72 6.306C.636 6.223.603 6.1.616 5.958c-.013-.141.02-.264.104-.348l.006-.006c.07-.138.17-.278.299-.406.128-.129.268-.23.406-.3L5.54.791c.222-.222.718-.085 1.109.305.39.39.527.887.305 1.109L4.158 5z"/>'
  }
})
